module.exports = __webpack_public_path__ + "static/media/flow_5.6b7f72d4.gif";